import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';
import configureSentry from './components/tools/SentryConfig';
configureSentry()

ReactDOM.render(<App />, document.getElementById('root'));
//registerServiceWorker();
unregister();
